import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as LucideIcons from 'lucide-react';

const GameStatsDashboard = ({ userStats }) => {
    const { t } = useTranslation();

    const games = [
        { id: 'auraEater', name: 'Aura Eater', icon: 'Flame', scoreKey: 'auraEaterHighScore' },
        { id: 'synapticStacking', name: 'Synaptic Stacking', icon: 'Layers', scoreKey: 'synapticStackingHighScore' },
        { id: 'synapticSerpent', name: 'Synaptic Serpent', icon: 'Spline', scoreKey: 'synapticSerpentHighScore' },
        { id: 'cosmicAscent', name: 'Cosmic Ascent', icon: 'Rocket', scoreKey: 'cosmicAscentHighScore' },
        { id: 'starlightSentinel', name: 'Starlight Sentinel', icon: 'Shield', scoreKey: 'starlightSentinelHighScore' }
    ];

    const totalGamesPlayed = userStats?.gamesPlayed || 0;
    const totalSoulsEarned = userStats?.totalSoulsEarned || 0;

    return (
        <div className="bg-gray-900/50 rounded-2xl p-6 border border-white/10 mt-8">
            <h3 className="text-2xl font-bold text-white font-orbitron mb-6 flex items-center gap-2">
                <LucideIcons.BarChart2 className="text-cyan-400" />
                {t('gameStats.title', 'Career Profile')}
            </h3>

            <div className="grid grid-cols-2 gap-4 mb-8">
                <div className="bg-white/5 rounded-xl p-4 border border-white/5">
                    <div className="text-gray-400 text-sm uppercase tracking-wider mb-1">{t('gameStats.totalGames', 'Total Games')}</div>
                    <div className="text-3xl font-bold text-white">{totalGamesPlayed}</div>
                </div>
                <div className="bg-white/5 rounded-xl p-4 border border-white/5">
                    <div className="text-gray-400 text-sm uppercase tracking-wider mb-1">{t('gameStats.totalSouls', 'Souls Harvested')}</div>
                    <div className="text-3xl font-bold text-purple-400">{totalSoulsEarned}</div>
                </div>
            </div>

            <h4 className="text-lg font-bold text-gray-300 mb-4">{t('gameStats.personalBests', 'Personal Bests')}</h4>
            <div className="space-y-3">
                {games.map(game => {
                    const Icon = LucideIcons[game.icon];
                    const highScore = userStats?.[game.scoreKey] || 0;
                    
                    return (
                        <div key={game.id} className="flex items-center justify-between bg-black/40 p-3 rounded-lg border border-white/5">
                            <div className="flex items-center gap-3">
                                <div className="p-2 bg-white/5 rounded-lg text-cyan-400">
                                    <Icon size={18} />
                                </div>
                                <span className="font-medium text-gray-200">{game.name}</span>
                            </div>
                            <span className="font-bold text-white font-mono text-lg">{highScore.toLocaleString()}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default GameStatsDashboard;
